const filterListModalfilterUser = {
  filter: 'FILTROS',
  clear: 'borrar todos los filtros'
};

export default filterListModalfilterUser;
